import { Model } from "appworks/model/model";
import { ButtonControl } from "appworks/ui/controls/standard/button/button-control";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { UIElements } from "gameiom/wrapper/wrapper-data";
import { HomeCommand } from "slotworks/commands/betbar/home-command";

export class AgsHomeButtonControl extends ButtonControl {
    public setEnabled(enabled: boolean): void {
        const displayHomeButton: boolean = gameiomModel.displayButtons.get(UIElements.homeButton);
        this.button.setVisible(enabled && displayHomeButton);
    }

    protected onClick(): void {
        const { homeURL } = Model.read().settings;
        HomeCommand(homeURL, () => gameWrapper.exitGame()).execute();
        super.onClick();
    }
}
